
export interface QuestionnaireSettings {
  answered: boolean;
  question1Answer: string;
  question2Answer: string;
  question3Answer: string;
  question4Answer: string;
  question5Answer: string;
}

// What do you want to achieve with OnlineCourseHost.com?
export const QUESTION_1_ANSWERS = {
  option1: "I want to sell online courses",
  option2: "I want to train Employees",
  option3: "I want to train Customers",
  option4: "I want to offer free training or acquire leads",
  option5: "I want to both sell online courses and provide training",
  option6: "I’m just playing around"
};

// Are you currently teaching online?
export const QUESTION_2_ANSWERS = {
  option1: "Yes, I am teaching online with another platform",
  option2: "I am currently teaching but not online",
  option3: "I am teaching online (webinars, etc) but I don’t have an online course",
  option4: "I want to start teaching online"
}

// What is the size of your audience?
export const QUESTION_3_ANSWERS = {
  option1: "I am just getting started",
  option2: "1-100",
  option3: "101-1,000",
  option4: "1,001-10,000",
  option5: "10,001-100,000",
  option6: "100,000+"
}

// What is your industry?
export const QUESTION_4_ANSWERS = {
  option1: "Arts, Crafts & Hobbies",
  option2: "Business & Marketing",
  option3: "Coaching & Consulting",
  option4: "College & Higher Education",
  option5: "Corporate & Enterprise",
  option6: "Design, Photo & Video",
  option7: "Fashion & Beauty",
  option8: "Finance, Investing & Real Estate",
  option9: "Food & Culinary",
  option10: "Health & Fitness",
  option11: "K-12 Education",
  option12: "Language teaching",
  option13: "Media & Publishing",
  option14: "Music & Dance",
  option15: "Non-Profit/NGO & Governmental",
  option16: "Personal development & Mental health",
  option17: "Professional Education & Career development",
  option18: "Religion & Spirituality",
  option19: "Software & Tech",
  option20: "Tourism & Hospitality"
}

// What best describes your role?
export const QUESTION_5_ANSWERS = {
  option1: "Author",
  option2: "Blogger",
  option3: "Coach",
  option4: "Consultant",
  option5: "Enterpreneur/Executive",
  option6: "Professional trainer",
  option7: "Public speaker",
  option8: "Small business owner",
  option9: "Social Media influencer",
  option10: "Teacher/Academic",
  option11: "I am a freelancer, setting this up for a client",
  option12: "I work for a larger company/team",
  option13: "Udemy or Skillshare instructor",
}

